import React from "react";
import "../css/privacy.scss";

function CookiePolicy() {
  return (
    <main className="cookies policy-page">
      <div className="policy-container">
        <p className="policy-updated">Last updated: 7 September 2026</p>
        <h1 className="policy-title">Cookie Notice</h1>
        <div className="policy-content">
          <p>This notice explains the cookies and similar browser storage used on uightparcel.shop. Despite the common term “cookie notice”, the current site uses local storage rather than advertising or analytics cookies.</p>

          <h2>What is browser storage?</h2>
          <p>Cookies are small text files stored by a website. Local storage is a related browser feature that keeps small pieces of information on your device. Both can remember information between page visits.</p>

          <h2>Storage currently used</h2>
          <div className="storage-table-wrap">
            <table className="storage-table">
              <thead><tr><th>Name</th><th>Type</th><th>Purpose</th><th>Duration</th></tr></thead>
              <tbody>
                <tr><td><code>cartItems</code></td><td>Local storage</td><td>Remembers products, size, colour and quantity in your selection.</td><td>Until you clear the selection or browser storage.</td></tr>
                <tr><td><code>uightparcel-cookie-notice</code></td><td>Local storage</td><td>Remembers that you dismissed this notice.</td><td>Until browser storage is cleared.</td></tr>
              </tbody>
            </table>
          </div>

          <h2>Non-essential cookies</h2>
          <p>We do not currently set analytics, personalisation or advertising cookies. If that changes, this notice and the control shown on the site must be updated before those technologies are enabled.</p>

          <h2>Your controls</h2>
          <p>You can clear or block browser storage in your browser settings. Blocking local storage may prevent the site from remembering your selection or notice choice. The “Cookie notice settings” link in the footer reopens the notice.</p>

          <h2>Third-party services</h2>
          <p>The website does not currently embed third-party social feeds, videos, payment forms, analytics or advertising pixels. Your browser or hosting provider may still process technical request data as described in our Privacy Policy.</p>

          <h2>Contact</h2>
          <p>Questions about browser storage can be sent to <a href="mailto:track@uightparcel.shop?subject=Cookie%20notice">track@uightparcel.shop</a>.</p>
        </div>
      </div>
    </main>
  );
}

export default CookiePolicy;
